import { queryClient } from '@store/queryClient';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import { QueryClientProvider } from '@tanstack/react-query';

import './fonts/fonts.css';
import './global.css';
import './i18n/config';
import { configure } from 'mobx';

import { store } from '@store';
import { Page } from '@core/Page';
import ReactDOM from 'react-dom';

(ReactDOM as any).findDOMNode = (instance: any) => {
    if (!instance) return null;
    if (instance instanceof HTMLElement) return instance;
    return instance.nodeType ? instance : instance.render ? null : instance;
};
configure({
    enforceActions: 'observed',
    useProxies: 'always',
    disableErrorBoundaries: false,
});

export function App() {
    return (
        <Provider {...store}>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <Page />
                </BrowserRouter>
            </QueryClientProvider>
        </Provider>
    );
}
